import deviceType from 'UTILS/window/deviceType';
import tabVisibilityHandler from 'UTILS/DOM/tabVisibilityHandler';

const refresh = () => window.location.reload();

if (deviceType() !== 'desktop') {
  tabVisibilityHandler(refresh);
}
